import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FiCamera, FiLock, FiChevronDown } from 'react-icons/fi';
import { FaStore } from 'react-icons/fa';
import { firestore } from '../../../config/firebase';
import { signIn, signOut } from '../../../store/actions/authActions';
import { createUser, clearUserData } from '../../../store/actions/userActions';
import { createCurrency } from '../../../store/actions/currencyActions';
import Sellers from '../../Sellers/Sellers';
import Spinner from '../../UIComponents/Spinner';

import defaultImg from '../../../assets/img/default/store.svg';
import './UserProfile.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import lang from './lang';

const API_KEY = "7033825bfe31262791b5"; //https://www.currencyconverterapi.com/docs
const CURRENCY_TYPE = "USD_UZS,RUB_UZS"; //https://www.currencyconverterapi.com/docs
const siteUrl = 'https://api.carpetking.uz';

class UserProfie extends Component {
    state = {
        active: false,
        id: '',
        img: '',
        name: '',
        email: '',
        lang: 'en',
        paid: true,
        admin: true,
        phone: '',
        address: '',
        currency: 'USD',
        lastName: '',
        progress: 0,
        firstName: '',
        display: 'none',
        updatedAt: Date.now(),
        msg: { msgStatus: false, msgType: 'success', msg: '' },
        readOnly: true,
        toggleAuth: 'hide-me',
        fileName: 'Choose file',
    }

    componentDidMount() {
        const { active, uzsAmount } = this.props.user;

        if (!uzsAmount) {
            axios.get(`//free.currconv.com/api/v7/convert?q=${CURRENCY_TYPE}&compact=ultra&apiKey=${API_KEY}`)
                .then(res => {
                    firestore
                        .doc('users/' + this.props.user.id)
                        .update({ uzsAmount: res.data.USD_UZS })
                        .then(doc => {
                            this.props.createUser({ ...this.props.user, updatedAt: Date.now(), uzsAmount: res.data.USD_UZS })
                            return this.setState({ ...res.data, active: false }, () => {
                                return this.props.createCurrency({
                                    uzsAmount: res.data.USD_UZS,
                                    usdAmount: 1,
                                    USD_UZS: res.data.USD_UZS,
                                    RUB_UZS: 0,
                                    custom: false,
                                    active: false,
                                });
                            });
                        });


                })
                .catch(err => console.log(err))
        } else {
            this.setState({ ...this.props.user, updatedAt: Date.now(), readOnly: active ? true : false });
        }


    }

    // Close alert messages
    alertMessageHandler = () => {
        this.setState({ msg: { msgStatus: false } });
    }

    inputHandler = (e) => {
        const { name, value } = e.target;
        if (name === 'img') {
            this.setState({ fileName: value.slice(value.lastIndexOf('\\') + 1) })
        } else {
            this.setState({ ...this.state, [name]: value });
        }

    }

    editHandler = () => {
        this.setState(prevState => {
            return { readOnly: !prevState.readOnly }
        });
    }

    // fileHandler = (e) => {
    //     e.preventDefault();
    //     const { files } = this.fileInput;
    //     this.setState({ fileName: files[0].name });

    //     // if Img exist deleted the old one first
    //     if (this.state.img.includes('https://firebasestorage.googleapis.com')) {
    //         storage.refFromURL(this.state.img).delete();
    //     }
    //     const currentFile = userStorage.child(this.props.auth.uid + '/profile/profile-img').put(files[0]);
    //     currentFile.on('state_changed',
    //         (snapshot) => {
    //             // Check the status of the upload
    //             const status = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //             this.setState({ progress: status });
    //         },
    //         (err) => {
    //             // if error occurs
    //             this.setState({ msg: err.message })
    //         },
    //         () => {
    //             // get full path of the image
    //             currentFile.snapshot.ref.getDownloadURL().then((downloadURL) => {
    //                 this.setState({});
    //                 firestore.collection('users')
    //                     .doc(this.state.id)
    //                     .update({ img: downloadURL })
    //                     .then(() => {
    //                         // update the state 
    //                         this.setState({ ...this.state, img: downloadURL, msg: { msg: 'Img has been sasved successfully', msgStatus: true, msgType: 'success' } });
    //                     }).catch(err => {
    //                         // update the state 
    //                         this.setState({ msg: { msg: err.message, msgStatus: true, msgType: 'danger' } });
    //                     })


    //             });
    //         }
    //     )

    // }
    fileHandler = (e) => {
        e.preventDefault();
        const { files } = this.fileInput;
        this.setState({ fileName: files[0].name, display: 'flex' });

        const formData = new FormData();
        formData.append('uid', this.state.id);
        formData.append('img', files[0]);
        this.profileImgRef.src = defaultImg;
        let url = '';
        if (process.env.NODE_ENV !== 'development') {
            url = siteUrl + '/users/profile/img';
        } else {
            url = '/users/profile/img';
        }
        axios.post(
            url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                firestore
                    .collection('users')
                    .doc(this.state.id)
                    .update({ demoImg: res.data.url })
                    .then(() => {
                        this.setState({ img: res.data.url, msg: { msg: lang[this.state.lang].messages.editImg, msgStatus: true, msgType: 'success' }, display: 'none' })
                        this.profileImgRef.src = res.data.url + '?' + new Date().getTime();
                    })
                    .catch((err) => {
                        this.setState({ msg: { msg: err.message, msgStatus: true, msgType: 'danger' }, display: 'none' });
                    })
            })
            .catch(err => console.log(err))


    }

    formhandler = (e) => {
        e.preventDefault();
        const { progress, msg, createdAt, readOnly, toggleAuth, ...data } = this.state;
        // create the user
        firestore.collection('users')
            .doc(this.state.id)
            .set({ ...data, createdAt: createdAt ? createdAt : Date.now() });

        // update the state 
        this.setState({ msg: { msg: lang[this.state.lang].messages.editImg, msgStatus: true, readOnly: true, msgType: 'success' } });
        this.props.createUser({ ...data })
    }

    authHandler = (event) => {
        event.preventDefault();
        // const { password, uid } = this.props.user.currentUser;
        axios({
            method: 'post',
            url: `/users/edit/${this.state.id}`,
            data: {
                email: this.state.email,
                password: this.state.password
            }
        }).then(res => {
            const { data } = res;
            console.log(data);

            if (data.success) {
                Swal.fire({
                    type: 'success',
                    title: data.msg[this.props.user.lang],
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    type: 'error',
                    title: data.msg[this.props.user.lang],
                    timer: 10000,
                    showCloseButton: true
                });
            }
            // this.setState({ msg: { msg: data.msg[this.props.user.lang], msgType: data.msgType, msgStatus: true } })
        }).catch(err => console.log(err))
    }

    toggleAuthInput = () => {
        const toggleClass = this.state.toggleAuth.includes('hide-me') ? 'show-me animated slideInDown' : 'hide-me animated slideOutUp';
        this.setState({ toggleAuth: toggleClass });
    }

    removeAccountHandler = (e) => {
        e.preventDefault();

        // Swal.fire({
        //     title: "Delete My Account",
        //     text: "Do you really want to delete your account?",
        //     type: 'warning',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonText: "No, cancel!",
        //     cancelButtonColor: '#d33',
        //     confirmButtonText: "Yes, delete it!"
        // }).then((result) => {
        //     this.setState({ display: 'flex' });

        //     if (result) {

        axios.post(`/users/delete/${this.props.user.id}`)
            .then(res => {
                console.log(res.data);
                this.setState({ display: 'none' });
                firestore
                    .collection('users')
                    .doc(this.props.user.id)
                    .delete()
                    .then(res => {

                        this.props.signout();
                    }).catch(err => {
                        console.log(err)
                    });


            })
            .catch(err => {
                this.setState({ display: 'none' });

                Swal.fire({
                    title: "Error",
                    text: err.message,
                    type: 'error',
                    showCloseButton: true
                })
            })
        //     }
        // })


    }


    render() {
        const {
            title,
            form,
            note,
            editBtn,
        } = lang[this.state.lang];

        return (
            <div className="mt-5 pt-4 bg-white" id="user-profile">
                <Spinner display={this.state.display} />
                {
                    <div
                        className={`alert alert-${this.state.msg.msgType} mb-5`}
                        style={{ display: this.state.msg.msgStatus ? 'block' : 'none' }}
                    >
                        {this.state.msg.msg}
                        <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>}

                <form autoComplete="new-password">
                    <h3 className="text-center mb-4">{title}</h3>
                    <div className="row">
                        <div className="col-md-4 col-lg-4 text-center">
                            <img
                                src={this.state.img || defaultImg}
                                onError={(e) => e.target.src = defaultImg}
                                alt={this.state.name}
                                className="img-fluid profile-img"
                                ref={ref => this.profileImgRef = ref}
                            />
                            <div className="input-group mb-3 uploader mx-auto">

                                {
                                    this.state.name ? (
                                        <div className="custom-file">
                                            <input
                                                type="file"
                                                className="custom-file-input"
                                                name="img"
                                                onChange={(e) => this.fileHandler(e)}
                                                ref={(ref) => this.fileInput = ref}
                                                id="file-upload"
                                            />
                                            <FiCamera id="camera" />
                                            {/* <label className="custom-file-label">Browse</label> */}
                                        </div>
                                    ) : null
                                }
                            </div>
                        </div>
                        <div className="col-md-8 offset-lg-1 col-lg-7">
                            <div className="d-flex" id="store-name">
                                <label><FaStore /> {form.name}*</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={form.name}
                                    name="name"
                                    onChange={(e) => this.inputHandler(e)}
                                    defaultValue={this.state.name}
                                    readOnly={this.state.readOnly}
                                />
                            </div>
                            <hr className="mb-n1" />
                            <div className="row">
                                <div className="col-sm-6 pl-sm-0">
                                    <label>{form.firstName}*</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={form.firstName}
                                        name="firstName"
                                        onChange={(e) => this.inputHandler(e)}
                                        defaultValue={this.state.firstName}
                                        readOnly={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-sm-6 pr-sm-0">
                                    <label>{form.lastName}*</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={form.lastName}
                                        name="lastName"
                                        onChange={(e) => this.inputHandler(e)}
                                        defaultValue={this.state.lastName}
                                        readOnly={this.state.readOnly}
                                    />
                                </div>

                                <div className="col-sm-6 pl-sm-0">
                                    <label>{form.phone}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder={form.phone}
                                        name="phone"
                                        onChange={(e) => this.inputHandler(e)}
                                        defaultValue={this.state.phone}
                                        readOnly={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-sm-6 pr-sm-0">
                                    <label>{form.address}</label>
                                    <input type="password" hidden name="password-hide" />
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={form.address}
                                        name="address"
                                        onChange={(e) => this.inputHandler(e)}
                                        defaultValue={this.state.address}
                                        readOnly={this.state.readOnly}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-6 pl-sm-0">
                                    <label>{form.language}</label>
                                    <select
                                        name="lang"
                                        className="form-control"
                                        readOnly={this.state.readOnly}
                                        value={this.state.lang}
                                        onChange={(e) => this.inputHandler(e)}
                                    >
                                        <option value="uz">UZ</option>
                                        <option value="ru">RU</option>
                                        <option value="en">EN</option>
                                    </select>
                                </div>
                                <div className="col-6 pr-sm-0">
                                    <label>{form.storeCurrency}</label>
                                    <select
                                        name="currency"
                                        className="form-control"
                                        readOnly={this.state.readOnly}
                                        value={this.state.currency}
                                        onChange={(e) => this.inputHandler(e)}
                                    >
                                        <option value="UZS">UZS</option>
                                        <option value="USD">$ USD</option>
                                    </select></div>
                            </div>
                            <hr />
                            {
                                this.props.auth.userType === 'admin' &&

                                (<React.Fragment>
                                    <span onClick={this.toggleAuthInput} className="btn btn-outline-success btn-sm">{form.authBtn} <FiLock />  <span className="ml-2"><FiChevronDown /></span> </span>

                                    <div id="auth-input" className={`mb-3 ${this.state.toggleAuth}`}>
                                        <div className="form-group border-top mt-3 mb-1">
                                            <label>{form.email}</label>
                                            <input type="password" hidden />
                                            <input type="email" hidden />
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                placeholder={form.email}
                                                value={this.state.email}
                                                autoComplete='email'
                                                onChange={(e) => this.inputHandler(e)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="mt-0">{form.password}</label>
                                            <input
                                                type="password"
                                                name="password"
                                                className="form-control"
                                                placeholder={form.password}
                                                onChange={(e) => this.inputHandler(e)}
                                                defaultValue={this.state.password}
                                                required
                                                min="6"
                                            />
                                        </div>
                                        <button onClick={this.authHandler} className="btn btn-success btn-sm">{form.authUpdateBtn}</button>
                                        <button onClick={this.removeAccountHandler} className="btn btn-danger btn-sm ml-auto">{form.authDeleteBtn || 'Remove Account'}</button>
                                    </div>
                                </React.Fragment>
                                )

                            }

                            <hr />
                            <button className="btn btn-primary mb-4 btn-block align-self-center" onClick={(event) => this.formhandler(event)}>{form.updateBtn}</button>
                            <p id="edit-profile">{note} <span onClick={() => this.editHandler()} className="btn btn-sm btn-link">{editBtn}</span>
                            </p>
                        </div>
                    </div>
                </form>
                <Sellers />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createUser: (user) => dispatch(createUser(user)),
        clearUser: () => dispatch(clearUserData()),
        signIn: () => dispatch(signIn),
        signOut: () => dispatch(signOut),
        createCurrency: (data) => dispatch(createCurrency(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserProfie));